module.exports = __webpack_public_path__ + "img/f1b3697.jpg";